module.exports = __webpack_public_path__ + "static/img/philips_prod.7f4b56e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code/philips_prod.jpg
// module id = dmMZ
// module chunks = 0